import SvgEditImage from '@common/__generated__/icon/components/SvgEditImage';
import { Button } from '@common/components/atom/Button/Button';
import { Checkbox } from '@common/components/atom/Checkbox/Checkbox';
import { Input } from '@common/components/atom/Input/Input';
import { InputDecorator } from '@common/components/atom/InputDecorator/InputDecorator';
import { Modal } from '@common/components/atom/Modal/Modal';
import { Radio } from '@common/components/atom/Radio/Radio';
import { cn } from '@common/utils';
import React, { useState } from 'react';

import type { CustomImageOptions } from '../_utils/CustomImage';

interface ImageEditButtonProps {
  onClick: () => void;
  selectedOptions: CustomImageOptions | null;
  onSubmit: () => void;
  onWidthChange: (width: number | null) => void;
  onIsBorderRadiusChange: (isBorderRadius: boolean) => void;
  onAlignChange: (align: CustomImageOptions['align']) => void;
  disabled?: boolean;
}

/**
 * 에디터 툴바의 이미지 속성 수정 버튼
 */
export const ImageEditButton = ({
  onClick,
  selectedOptions,
  onSubmit,
  onWidthChange,
  onIsBorderRadiusChange,
  onAlignChange,
  disabled,
}: ImageEditButtonProps) => {
  const [isModalOpened, setIsModalOpened] = useState(false);

  const handleWidthChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;

    if (inputValue === '') {
      onWidthChange(null);

      return;
    }

    const numberValue = Number(inputValue);

    if (!isNaN(numberValue)) {
      onWidthChange(numberValue);
    }
  };

  return (
    <>
      <button
        className={cn(
          'flex size-24 items-center justify-center text-Gray-900',
          {
            'cursor-not-allowed text-Gray-400': disabled,
          },
        )}
        disabled={disabled}
        type="button"
        onClick={() => {
          setIsModalOpened(true);
          onClick();
        }}
      >
        <SvgEditImage className="size-20" />
      </button>
      <Modal opened={isModalOpened} onClose={() => setIsModalOpened(false)}>
        <article className="mb-32 flex flex-col gap-16">
          <InputDecorator label="가로(px)">
            <Input
              value={selectedOptions?.maxWidth ?? ''}
              onChange={handleWidthChange}
            />
          </InputDecorator>
          <InputDecorator label="세로(px)">
            <p>세로 사이즈는 비율에 따라 자동으로 조절됩니다.</p>
          </InputDecorator>
          <InputDecorator label="Image Radius">
            <Checkbox
              checked={selectedOptions?.isBorderRadius}
              onCheckedChange={onIsBorderRadiusChange}
            />
          </InputDecorator>
          <InputDecorator label="정렬">
            <Radio.Group
              value={selectedOptions?.align}
              onChange={onAlignChange}
            >
              <Radio.Item value="left">왼쪽</Radio.Item>
              <Radio.Item value="center">가운데</Radio.Item>
              <Radio.Item value="right">오른쪽</Radio.Item>
            </Radio.Group>
          </InputDecorator>
        </article>
        <footer className="flex w-full gap-8">
          <Button
            className="flex-1"
            onClick={() => {
              setIsModalOpened(false);
              onSubmit();
            }}
          >
            설정
          </Button>
          <Button
            className="flex-1"
            theme="sub-fill"
            onClick={() => {
              setIsModalOpened(false);
            }}
          >
            취소
          </Button>
        </footer>
      </Modal>
    </>
  );
};
